import { lazy } from 'react';

const SendTransferCollectivePlanConfig = {
	settings: {
		layout: {
			config: {
				footer: {
					display: false
				},
			}
		}
		
	},
	routes: [
		{
			path: '/plan/consult/send-transfer-info',
			component: lazy(() => import('./SendTransferContainer'))
		}
	]
};

export default SendTransferCollectivePlanConfig;




